import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconCall from '../../../assets/icons/icon_call.svg';
import iconEmail from '../../../assets/icons/icon_email.svg';
import iconClose from '../../../assets/icons/icon_close.svg';
import iconWarning from '../../../assets/icons/icon_warning.svg';
// Hooks
import { datosContactoFormatted } from '../../../utils/Hooks/datosContactoFormatted';

function ModalDatosContacto({ openModals, onHandleClose }) {
  const { datosContactoPrestadorLogeado, solicitudProps, setSolicitudProps, prestadoresOsde } =
    useContext(AgendaContext);

  const datosPrestador = datosContactoFormatted(datosContactoPrestadorLogeado);
  const navigate = useNavigate();

  const handleNavigate = () => {
    setSolicitudProps({
      ...solicitudProps,
      datosContacto: datosPrestador.datosPrestador,
      filial: prestadoresOsde?.consultorioOsde[0]?.filial
    });
    navigate('/prestador/registro');
  };

   const isConfirmDisabled =
   (!datosPrestador.datosTelefono || datosPrestador.datosTelefono.length === 0) &&
   (!datosPrestador.datosEmail || datosPrestador.datosEmail.length === 0);

  return (
    <SmallModalContainer open={openModals} onClose={onHandleClose}>
      <Box
        component="img"
        sx={{
          width: '24px',
          height: '24px',
          cursor: 'pointer',
          position: 'absolute',
          top: '1rem',
          right: '1rem'
        }}
        alt="img not found"
        src={iconClose}
        onClick={onHandleClose}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Box
          component="img"
          sx={{ width: '54px', height: '54px' }}
          alt="img not found"
          src={iconWarning}
        />
        <Typography variant="h1">Antes de continuar</Typography>
        <Typography variant="h4">
          Confirmá que tus datos de contacto sean correctos para comenzar la solicitud.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            backgroundColor: '#E7E9F7',
            padding: '16px',
            borderRadius: '16px'
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              gap: '8px'
            }}>
            {datosPrestador.datosTelefono?.map((telefono, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Box
                  component="img"
                  sx={{ width: '16px', height: '16px' }}
                  alt="img not found"
                  src={iconCall}
                />
                <Typography variant="h5">{telefono}</Typography>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              gap: '8px'
            }}>
            {datosPrestador.datosEmail?.map((email, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Box
                  component="img"
                  sx={{ width: '16px', height: '16px' }}
                  alt="img not found"
                  src={iconEmail}
                />
                <Typography variant="h5">{email}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginTop: '2px' }}>
          <Typography variant="bodyS" component="p">
            En caso de tener que modificarlos, te dirigiremos a Extranet. Tené en cuenta que la
            actualización puede demorar unos minutos. Una vez realizado el cambio, volvé a comenzar
            la solicitud.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          marginTop: '2em',
          width: '100%'
        }}>
        <Button
          onClick={() => {
            onHandleClose();
            window.open(
              'https://extranet.osde.com.ar/OSDEExtranet/appexterna/invocarAppExterna.do?urlApp=850ee0fb92318cb5a38180980a80751e',
              '_blank'
            );
          }}
          target="_blank"
          variant="outlined"
          sx={{ width: '50%', height: '48px' }}>
          Modificar
        </Button>
        <Button
          variant="contained"
          disabled={isConfirmDisabled}
          onClick={() => handleNavigate()}
          sx={{ width: '50%', height: '48px' }}>
          Confirmar
        </Button>
      </Box>
    </SmallModalContainer>
  );
}

export default ModalDatosContacto;
